import BaseInfoIcon from "./BaseInfoIcon";

const SkuInfoIcon = ({ sku }) => {
  const title = sku ? "Brandhub generated item #" : "Customer-provided SKU";
  return <BaseInfoIcon title={title} />;
};

export default SkuInfoIcon;
